import clsx from 'clsx';
import { memo } from 'react';
import { Icons } from './icons';
import { jsx as _jsx } from "react/jsx-runtime";
const Icon = ({
  icon,
  size = 'md',
  className,
  ...restProps
}) => {
  if (!Icons[icon]) {
    return null;
  }
  const Component = Icons[icon];
  return /*#__PURE__*/_jsx(Component, {
    className: clsx('ima-icon', `ima-icon--size-${size}`, className),
    ...restProps
  });
};
export { Icon };
export default /*#__PURE__*/memo(Icon);